import ApplicationController from "./application_controller";

//import TomSelect from 'tom-select/dist/esm/tom-select'
import TomSelect from 'tom-select'
import 'tom-select/dist/esm/plugins/remove_button/plugin'
import 'tom-select/dist/esm/plugins/dropdown_input/plugin'
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

export default class extends ApplicationController {
    static targets = [ "input" ]

    connect() {
        console.log('Tom-Select Sorted Controller connected for:', this.element);
        this.initializeTomSelect();
    }

    disconnect() {
        this.destroyTomSelect();
    }

    validate() {
        const input = this.inputTarget;
        if (input.required && !input.value) {
            input.setCustomValidity('Dieses Feld ist erforderlich');
        } else {
            input.setCustomValidity('');
        }
    }

    initializeTomSelect() {
        // Return early if no element is associated with the controller.
        if (!this.element) return;

        const allowCreate = this.inputTarget.dataset.tomselectCreate === 'true';
        const isRequired = this.inputTarget.required;
        const keepOrder = this.inputTarget.dataset.tomselectKeepOrder === 'true' || this.element.dataset.tomselectKeepOrder === 'true';
        
        console.log('Tom-Select Sorted Debug:', {
            element: this.inputTarget,
            keepOrder: keepOrder,
            inputDataset: this.inputTarget.dataset,
            containerDataset: this.element.dataset,
            tomselectKeepOrder: this.inputTarget.dataset.tomselectKeepOrder,
            containerKeepOrder: this.element.dataset.tomselectKeepOrder
        });

        // Fetch options from the select element
        let options = Array.from(this.inputTarget.options).map(option => {
            return {
                value: option.value,
                text: option.text,
                subtext: option.dataset.subtext
            };
        });

        // Wenn keepOrder aktiviert ist, behalte die ursprüngliche Reihenfolge
        if (keepOrder) {
            console.log('Tom-Select Sorted: Behalte ursprüngliche Reihenfolge der Optionen');
            // Füge einen Index hinzu, um die ursprüngliche Reihenfolge zu bewahren
            options = options.map((option, index) => ({
                ...option,
                $order: index
            }));
        }

        let plugins = {};
        if (allowCreate) {
            plugins.remove_button = {
                title: 'Entfernen'
            };
        }
        if (keepOrder) {
            console.log('Tom-Select Sorted: Sortierung wird über $order beibehalten für', this.inputTarget);
            // Kein Drag & Drop Plugin - nur $order Sortierung
        }

        let placeholder = this.inputTarget.dataset.placeholder ? this.inputTarget.dataset.placeholder : "Bitte auswählen";

        this.tomselect = new TomSelect(this.inputTarget, {
            plugins: plugins,
            persist: false,
            allowEmptyOption: !isRequired,
            create: allowCreate,
            placeholder: placeholder,
            options: options,
            openOnFocus: true,
            preload: 'focus',
            closeAfterSelect: true,
            selectOnTab: true,
            maxOptions: 100,
            sortField: keepOrder ? [{ field: '$order', direction: 'asc' }] : undefined, // Sortiere nach ursprünglicher Reihenfolge wenn keepOrder: true
            render: {
                no_results: function (data, escape) {
                    return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '". Entfernen mit der ␛-Taste</div>';
                },
                option_create: function(data, escape) {
                    if (allowCreate) {
                        return '<div class="create"><strong>' + escape(data.input) + '</strong> hinzufügen &hellip;</div>';
                    } else {
                        return '';
                    }
                },
                option: function(data, escape) {
                    let subtext = data.subtext ? '<br/><span class="subtext text-xs text-gray-400 truncate">' + escape(data.subtext) + '</span>' : '';
                    return '<div class="option">' +
                        '<span class="title text-sm">' + escape(data.text) + '</span>' +
                        subtext +
                        '</div>';
                },
                item: function(data, escape) {
                    return '<div class="item text-sm">' + escape(data.text) + '</div>';
                },
                render: {
                    loading_more: function(data, escape) {
                        return `<div class="loading-more-results py-2 d-flex align-items-center"><div class="spinner"></div> Wird geladen</div>`;
                    }
                },
            },
            onInitialize: () => {
                this.inputTarget.classList.remove('hidden');
                
                if (keepOrder) {
                    console.log('Tom-Select Sorted: Ursprüngliche Reihenfolge wird über $order beibehalten');
                }
            },
            onChange: () => {
                this.validate();
            }
        });
    }

    destroyTomSelect() {
        if (this.tomselect) {
            this.tomselect.destroy();
        }
    }
}
